module.exports = __webpack_public_path__ + "static/media/Fisk_Logo.6f4c156c.svg";